import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Stack, Typography } from '@mui/material';

interface Props {
  manuallyApproved: boolean;
}

export default function ApprovalStatusLabel({ manuallyApproved }: Props) {
  return (
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="center"
      sx={{ color: 'success.main', fontWeight: 700, whiteSpace: 'nowrap' }}
    >
      <CheckCircleIcon fontSize="small" />
      <Typography variant="body2" fontWeight={700}>
        {manuallyApproved ? 'Manually approved' : 'Auto-approved'}
      </Typography>
    </Stack>
  );
}
